import { PaApi, baseOpts, processSuccess } from '@/services/PaApi'

export const BrandingTemplateModule = {
  namespaced: true,

  state: {
    branding_template: {},
    branding_templates: []
  },

  actions: {
    async createTemplate ({ commit, state }, params) {
      commit('setLoading', true, { root: true })

      await PaApi().post(
        '/admin/branding_templates', params.formdata
      ).then((resp) => {
        commit('storeTemplate', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async updateTemplate ({ commit, state }, params) {
      commit('setLoading', true, { root: true })

      await PaApi().put(
        '/admin/branding_templates/' + params.templateId,
        params.formdata
      ).then((resp) => {
        commit('storeTemplate', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async deleteTemplate ({ commit, state }, templateId) {
      commit('setLoading', true, { root: true })

      await PaApi().delete(
        '/admin/branding_templates/' + templateId
      ).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getTemplates ({ commit, state }) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/branding_templates'
      ).then((resp) => {
        commit('storeTemplates', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    },

    async getTemplate ({ commit, state }, templateId) {
      commit('setLoading', true, { root: true })

      await PaApi().get(
        '/admin/branding_templates/' + templateId
      ).then((resp) => {
        commit('storeTemplate', resp)
      }).finally(() => {
        commit('setLoading', false, { root: true })
      })
    }
  },

  mutations: {
    storeTemplates (state, payload) {
      state.branding_templates = processSuccess(payload, baseOpts)
    },

    storeTemplate (state, payload) {
      state.branding_template = processSuccess(payload, baseOpts)
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/BrandingTemplateModule.js